import React, { useState, useEffect, useContext } from "react";
import { getSummonerProfileContext } from "components/SummonerProfiles/SummonerProfileContext";
import { useSummonerProfile } from "api/summonerProfileApi";
import { useFetchSummonerMatchSummaries } from "api/matchSummaryApi.js";
import { getRiotAssetsContext } from "@outplayed/riot-assets";

const SummonerProfileBackground = (props) => {
  const { getChampionNameId, getChampionIdByName, getChampionSplashImg } = getRiotAssetsContext();
  const context = getSummonerProfileContext();
  const { summonerName, region, previewMode } = context;
  const { loading, data, error } = useSummonerProfile(region, summonerName, null, null);
  const {
    loading: matchSummariesLoading,
    data: matchSummariesData,
    error: matchSummariesError,
  } = useFetchSummonerMatchSummaries(region, summonerName, {}, { ssr: false });

  const { profileInit } = data || {};
  const { customizationData, memberStatus } = profileInit || {};
  const { fetchPlayerMatchSummaries } = matchSummariesData || {};
  const { matchSummaries } = fetchPlayerMatchSummaries || {};

  const [headerBg, setHeaderBg] = useState(customizationData?.headerBg);

  useEffect(() => {
    if (!loading && customizationData && customizationData.headerBg === "") {
      if (matchSummaries && matchSummaries.length > 0) {
        const champUsageMap = {};
        let mostCommonId = 0;
        let mostCommonCount = 0;

        matchSummaries.forEach((match) => {
          if (!champUsageMap[match.championId]) champUsageMap[match.championId] = 1;
          else champUsageMap[match.championId]++;

          if (champUsageMap[match.championId] > mostCommonCount) {
            mostCommonCount = champUsageMap[match.championId];
            mostCommonId = match.championId;
          }
        });
        setHeaderBg(`${getChampionNameId(mostCommonId)}_${1}`);
      }
    } else if (customizationData && customizationData.headerBg !== headerBg) {
      setHeaderBg(customizationData.headerBg);
    }
  }, [data, matchSummariesData]);

  const headerChampionSplit = (headerBg && headerBg.split("_")) || [];
  const championId = getChampionIdByName(headerChampionSplit[0]);
  const headerImg = getChampionSplashImg(championId, { splashId: headerChampionSplit[1] });

  return (
    (previewMode || headerBg) && (
      <div className="content-side-padding background-image-container" style={{}}>
        <div style={{ position: "relative", width: "100%", height: "100%" }}>
          <div className="bg-container">
            {previewMode ? (
              <img
                className="background-image"
                src={getChampionSplashImg(previewMode.key, { splashId: previewMode.splashNum })}
              />
            ) : (
              <img className="background-image" src={headerImg} />
            )}
          </div>
          <div className="gradient-container">
            <div className="gradient" />
          </div>
        </div>
      </div>
    )
  );
};

export default SummonerProfileBackground;
